import React from "react";
import {
  ClipboardDocumentIcon,
  BackspaceIcon,
} from "@heroicons/react/24/outline";
import CustomTitleTerms from "../termsAndConditions/customTitleTerms";
import CustomTermPoints from "../termsAndConditions/customTermPoints";
import CustomTextingCard from "../termsAndConditions/customCard";
import { useTranslation } from "react-i18next";
import CustomTermWithoutPoints from "../termsAndConditions/customTermWithoutPoints";

const ContainerPrivacyAndPolicy = () => {
  const { t, i18n } = useTranslation();

  const isRTL = i18n.language === "ar";

  return (
    <div
      className={`px-4 py-3 lg:px-0 lg:py-8 max-container ${
        isRTL ? "rtl" : "ltr"
      }`} // Set direction
      dir={isRTL ? "rtl" : "ltr"}
    >
      <div
        className={` ${
          isRTL ? "text-right" : "text-left"
        } lg:mx-0  py-6 lg:py-10  flex flex-col gap-y-2 flex flex-col gap-y-5`}
      >
        {/* Privacy Policy */}
        <CustomTitleTerms title={t("privacy_policy")} first={true} />
        <CustomTermPoints title={t("privacy_policyParag1")} />
        <CustomTermPoints title={t("privacy_policyParag2")} />
        <CustomTermPoints title={t("privacy_policyParag3")} />

        {/* Consent for Personal Information Transfer */}
        <CustomTextingCard
          title={t("privacy_policyTitle1")}
          Icon={ClipboardDocumentIcon}
          subTitle={t("privacy_policyParag4")}
        />

        <CustomTitleTerms title={t("privacy_policyTitle2")} />
        <CustomTermWithoutPoints title={t("privacy_policyParag5")} />
        <div className="space-y-2 ms-5">
          <CustomTermPoints title={t("privacy_policyParag6")} />
          <CustomTermPoints title={t("privacy_policyParag7")} />
          <CustomTermPoints title={t("privacy_policyParag8")} />
          <CustomTermPoints title={t("privacy_policyParag9")} />
        </div>

        {/* Data Collection and Usage */}
        <CustomTitleTerms title={t("privacy_policyTitle3")} />

        <CustomTermPoints title={t("privacy_policyParag10")} />
        <CustomTermPoints title={t("privacy_policyParag11")} />
        <CustomTermPoints title={t("privacy_policyParag12")} />
        <CustomTermPoints title={t("privacy_policyParag13")} />

        {/* Data Removal Requests */}
        <CustomTextingCard
          title={t("privacy_policyTitle4")}
          Icon={BackspaceIcon}
          subTitle={t("privacy_policyParag14")}
        />

        {/* Data Usage and Disclosure */}
        <CustomTitleTerms title={t("privacy_policyTitle5")} />
        <CustomTermPoints title={t("privacy_policyParag15")} />
        <CustomTermPoints title={t("privacy_policyParag16")} />
        <CustomTermPoints title={t("privacy_policyParag17")} />
        {/* <CustomTermPoints title={t('safetyDisclosure')} /> */}

        {/* <CustomTitleTerms title={t('dataRemovalRequest')} />
        <CustomTermPoints title={t('dataRemovalInstructions')} /> */}

        {/* Privacy Policy Amendments */}
        {/* <CustomTitleTerms title={t('privacyPolicyAmendments')} />
        <CustomTermPoints title={t('privacyPolicyReview')} /> */}
        <CustomTermWithoutPoints title={t("amendmentDate")} />
      </div>
    </div>
  );
};

export default ContainerPrivacyAndPolicy;
